import editorModalTemplate from "../views/create-statistic.tpl.html";
import StatisticCreateModalController from "./create-modal";

export default class AlDashboardsController {

    constructor($scope, $injector, $element) {
        this.scope = $scope;
        this.injector = $injector;
        this.element = $element;

        this.api = this.injector.get('$http');
        this.uibModal = this.injector.get('$uibModal');
        this.navService = this.injector.get('NavService');
        this.acl = this.injector.get('Acl');
        this.alert = this.injector.get('Alert');
        this.guestlist = null;
        this.maximizedStatistic = null;
        this.statistics = [];
    }

    $onInit() {
        this.refresh = () => {
            this.api.get("stats/guestlists/" + this.guestlist.id).then(({data}) => {
                this.statistics = data.data;
            })
                .catch(() => this.alert.error('Error', 'Error while fetching statistics information. Try again'));
        }

        this.maximize = (statistic) => {
            this.maximizedStatistic = statistic;
        }

        this.refresh();
        this._initTabs();
    }

    _initTabs() {
        const sideNavCustoms = [];

        sideNavCustoms.push({
            key: 'create-chart',
            label: 'Create Chart',
            icon: 'plus-circle',
            action: () => this.openNewChart()
        });

        this.navService.overrideMainSideNavActions(sideNavCustoms);
    }

    openNewChart() {
        this._openEditorModal(StatisticCreateModalController, {
            guestlist: this.guestlist,
            refresh: this.refresh
        }).then(() => {
        });
    }

    _openEditorModal(controller, extendedInformation) {
        extendedInformation = extendedInformation || {};

        return this.uibModal.open({
            controller,
            controllerAs: 'vm',
            templateUrl: editorModalTemplate,
            resolve: {
                extendedInformation: () => extendedInformation
            }
        }).result;
    }

}

AlDashboardsController
    .$inject = [
    '$scope',
    '$injector',
    '$element',
];



// WEBPACK FOOTER //
// ./src/app/modules/guestlists/components/al-guestlist-dashboard/controllers/component.js